import { getChatApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    GetUserInfoResponse,
} from '@/core/generated/api';
import type { ChatRole } from '../model/types';
import { mapChatRoleToApiRole } from '../model/mappers';

export { mapChatRoleToApiRole } from '../model/mappers';

/** Предоставляет backend-операции чата */
export const chatService = {
    /** Загружает административную карточку собеседника */
    async getUserInfo(appUserId: string, role: ChatRole): Promise<GetUserInfoResponse> {
        try {
            const response = await getChatApi()
                .getUserInfo({
                    appUserId,
                    role: mapChatRoleToApiRole(role),
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

};
